import React, { useState } from 'react';
import Card from 'v3/components/Card';
import Tooltip from 'v3/components/Tooltip';
import Text from 'v3/components/Text';
import { FaDollarSign, FaQuestionCircle } from 'react-icons/fa';
import theme from 'v3/theme';
import CardHeaderComponent from '../../components/CardHeaderComponent';
import HeaderTotalSummary from '../../components/HeaderTotalSummary';
import ToggleCurrency from '../../components/ToggleCurrency';
import ActionButton from '../../components/ActionButton';
import { useFreightValues } from '../../context';
import ValueDetailsRow from '../../components/ValueDetailsRow';
import ExtraFields from '../../components/ExtraFields';
import { SummaryRow } from '../../components/SummaryRow';

export default function ReceiveClientCardShow() {
  const {
    showDailyRate,
    customerFields,
    onChangeDailyRate,
    totalCustomerValue,
    receiveClientTags,
    customerExtraFields,
    shouldUseGrisAd,
    shouldUseCharge,
    shouldUseFerry,
    shouldUseICMS,
    realKm,
  } = useFreightValues();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card containerCardBoxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)">
      <CardHeaderComponent
        label="Receber Cliente Tomador"
        isOpen={isOpen}
        onToggleCard={() => setIsOpen(!isOpen)}
        rightSection={
          <ToggleCurrency>
            <ActionButton
              onClick={onChangeDailyRate}
              title={showDailyRate ? 'Cotação do dia' : 'Cotação informada'}
            >
              <FaDollarSign title={showDailyRate ? 'Cotação do dia' : 'Cotação informada'} />
            </ActionButton>
            <Tooltip
              content={
                <Text type="label" color="white">
                  Alterna entre valores da cotação do dólar no dia e a cotação informada no campo
                  Moeda.
                </Text>
              }
            >
              <FaQuestionCircle style={{ color: theme.colors.light_blue }} />
            </Tooltip>
          </ToggleCurrency>
        }
        tooltipContent="Todo o valor que é recebido pelo cliente deve ser destacado separadamente. Após preencher todos os campos irá chegar no Valor Cliente Tomador automaticamente "
        totalsSection={
          <HeaderTotalSummary
            label="Valor Cliente Tomador"
            totalInReal={totalCustomerValue.total}
            totalInDollar={totalCustomerValue.totalDollarValue}
          />
        }
        hasTagsRow
        tagsContent={receiveClientTags}
      />
      {isOpen && (
        <>
          <ValueDetailsRow
            label="Valor Frete Base"
            value={customerFields?.takerValue?.value}
            dollarValue={customerFields?.takerValue?.dollarValue}
          />
          {realKm?.value ? (
            <ValueDetailsRow
              label="Real Km"
              value={realKm?.value}
              dollarValue={realKm?.dollarValue}
            />
          ) : null}
          <ValueDetailsRow
            label="Pedágio"
            value={customerFields?.tollValue?.value}
            dollarValue={customerFields?.tollValue?.dollarValue}
            obs={customerFields.tollValue?.action?.name}
          />
          <ValueDetailsRow
            label="Descarga"
            value={customerFields?.dischargeValue?.value}
            dollarValue={customerFields?.dischargeValue?.dollarValue}
            obs={customerFields.dischargeValue?.action?.name}
          />
          {shouldUseGrisAd && (
            <ValueDetailsRow
              label="Griss"
              value={customerFields?.gris?.value}
              dollarValue={customerFields?.gris?.dollarValue}
              percentageValue={customerFields?.gris?.percentage}
              obs={customerFields.gris?.action?.name}
            />
          )}
          <ValueDetailsRow
            label="Ad valorem"
            value={customerFields?.adValorem?.value}
            dollarValue={customerFields?.adValorem?.dollarValue}
            percentageValue={customerFields?.adValorem?.percentage}
            obs={customerFields.adValorem?.action?.name}
          />
          {shouldUseCharge && (
            <ValueDetailsRow
              label="Taxa de carregamento"
              value={customerFields?.chargeValue?.value}
              dollarValue={customerFields?.chargeValue?.dollarValue}
              obs={customerFields.chargeValue?.action?.name}
            />
          )}
          {shouldUseFerry && (
            <ValueDetailsRow
              label="Balsa"
              value={customerFields?.ferry?.value}
              dollarValue={customerFields?.ferry?.dollarValue}
              obs={customerFields.ferry?.action?.name}
            />
          )}
          {shouldUseICMS && (
            <ValueDetailsRow
              label="ICMS"
              value={customerFields?.ICMS?.value}
              dollarValue={customerFields?.ICMS?.dollarValue}
              percentageValue={customerFields?.ICMS?.percentage}
              obs={customerFields.ICMS?.action?.name}
            />
          )}
          {customerExtraFields?.length > 0 ? (
            <>
              <Text type="regular" weight={500}>
                Valores extras
              </Text>
              <ExtraFields show fields={customerExtraFields} />
            </>
          ) : null}
          <SummaryRow
            label="Valor Cliente Tomador"
            totalInReal={totalCustomerValue?.total}
            totalInDollar={totalCustomerValue?.totalDollarValue}
            id="valor-tomador"
          />
        </>
      )}
    </Card>
  );
}
